export type ChartAxis = 'left' | 'right';

export const ChartLineTypes = [
    { value: 'line', label: 'Line' },
    { value: 'shortdash', label: 'Short dash' },
    { value: 'shortdashdot', label: 'Short dash dot' },
    { value: 'shortdashdotdot', label: 'Short dash dot dot' },
    { value: 'dot', label: 'Dot' },
    { value: 'dash', label: 'Dash' },
    { value: 'dashdot', label: 'Dash dot' },
    { value: 'longdash', label: 'Long dash' },
    { value: 'longdashdot', label: 'Long dash dot' },
    { value: 'longdashdotdot', label: 'Long dash dot dot' },
];
